module.exports = __webpack_public_path__ + "static/img/081.13bc3d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/yqs/081.png
// module id = /nLp
// module chunks = 0